import { Component, HostListener, inject, OnInit } from '@angular/core';
import { NavigationService } from '@services/navigation/navigation.service';
import { GlobalStoreService } from '@services/global-store/global-store.service';
import { FormulaireMouvementService } from '@services/formulaire-mouvement/formulaire-mouvement.service';

@Component({
  selector: 'app-modale-annuler',
  templateUrl: './modale-annuler.component.html',
  standalone: false,
})
export class ModaleAnnulerComponent implements OnInit {
  showValue = false;

  private readonly navigationService = inject(NavigationService);
  private readonly globalStoreService = inject(GlobalStoreService);
  private readonly formulaireMouvementService = inject(FormulaireMouvementService);
  constructor() {}

  ngOnInit(): void {
    this.globalStoreService.getEtatModale().subscribe((etat) => (this.showValue = etat));
  }

  @HostListener('window:oel-header-transactionnel.boutonRetourCliquee')
  handleBoutonAnnulerHeader(): void {
    this.globalStoreService.saveEtatAfficherModaleAnnuler(true);
  }
  showDialog() {
    this.globalStoreService.saveEtatAfficherModaleAnnuler(false);
  }
  redirectionAccueil() {
    this.formulaireMouvementService.setFormCourriel(null);
    this.formulaireMouvementService.setFormAdresse(null);
    this.formulaireMouvementService.setFormTelephone(null);
    this.globalStoreService.saveUpdateDataForm(null);
    this.globalStoreService.saveEtatAfficherModaleAnnuler(false);
    this.navigationService.naviguerVersCoordonnees();
  }
}
